import { signal } from '@preact/signals';
// Main AI chat state signal
export const aiChatState = signal({
    isOpen: false,
    sessionId: null,
    messages: [],
    context: null,
    isLoading: false,
    error: null,
    isMinimized: false,
    suggestClose: false,
    rating: null,
    showDelayedFeedback: false,
    approachingTurnLimit: false,
    remainingTurns: 0,
});
// Separate signal to track last closed session for delayed feedback
export const lastClosedSession = signal(null);
// Field update handler signal (function stored separately)
export const fieldUpdateHandler = signal(null);
// Initial session context signal
export const initialSessionContext = signal(null);
